import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { leaderboard: () => import('./LeaderboardPage.vue') },
} satisfies FeatureRoutes
